<div class="dialog-container">
  <!-- Header Section -->
  <div class="dialog-header">
    <div class="d-flex align-items-center">
      <mat-icon class="mr-2">{{ data.icon || 'description' }}</mat-icon>
      <div class="title">{{ data.title }}</div>
    </div>
    <div class="subtitle">{{ data.subtitle }}</div>
  </div>
  <mat-divider></mat-divider>

  <!-- Scrollable Content Section -->
  <form [formGroup]="uploadForm" class="form-container">
    <!--Additional Email Field-->
    <mat-form-field style="width: '100%'" appearance="fill" class="w-100">
      <mat-label>
        {{ 'shared.send-request-popup.additional-emails' | translate }}
      </mat-label>
      <mat-chip-grid #emailsChipList>
        <mat-chip
          *ngFor="let email of addedEmails"
          [selectable]="false"
          (removed)="removeEmail(email)"
        >
          {{ email }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="{{
            'shared.send-request-popup.additional-emails-placeholder'
              | translate
          }}"
          #emailInput
          formControlName="additionalEmail"
          [matChipInputFor]="emailsChipList"
          [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="
            addEmail(emailInput.value); emailInput.value = ''
          "
        />
      </mat-chip-grid>
      <mat-error
        *ngIf="
          uploadForm.controls.additionalEmail.hasError('email') ||
          emailValidationError
        "
      >
        {{
          'shared.send-request-popup.additional-emails.pattern-error'
            | translate
        }}
      </mat-error>
    </mat-form-field>

    <!-- remarks -->
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>{{
        'shared.send-request-popup.remarks' | translate
      }}</mat-label>
      <textarea
        data-testid="step-documents-description"
        type="text"
        matInput
        formControlName="remarks"
      ></textarea>
    </mat-form-field>

    <div class="drag-drop-container" *ngIf="isFileNeeded">
      <app-drag-and-drop
        [allowUpload]="true"
        [allowDelete]="true"
        [uploadDirectly]="false"
        [displayImg]="true"
        (triggerFileSelected)="triggerFileSelected($event)"
        [showUploadedFiles]="false"
        [allowedTypesNames]="data.allowedTypesNames"
        [allowedTypesRegex]="data.allowedTypesRegex"
        [maxSize]="data.maxSize"
        [remainingFilesCount]="fileCount"
        [remainingFiles]="true"
        required
      >
      </app-drag-and-drop>

      <app-display-data-in-dlt
        *ngIf="documentsDataList?.length > 0"
        [dataListArray]="documentsDataList"
        (onClickAction)="action($event)"
      >
      </app-display-data-in-dlt>
    </div>

    <ng-container *ngIf="isContactDetailsRequired">
      <div class="d-flex flex-row">
        <mat-checkbox
          [checked]="uploadForm.controls.isMailSelected.value"
          class="checkbox-style"
          (change)="requiredCheckOnEmail($event)"
        >
        </mat-checkbox>
        <el-multi-field
          class="col-11 pl-0"
          title="{{ 'Email Address (Type)' | translate }} "
          placeholder="{{ 'johndoe@example.com' | translate }}"
          inputFieldId="create_identity_input_phone_number"
          btnId="create_identity_btn_set_phone"
          [required]="false"
          [isConstant]="false"
          [data]="{
            type: 'EMAIL',
            value: uploadForm.controls.eMails.value,
            fieldConfig: null
          }"
          (onSetValue)="onValueChange($event)"
        ></el-multi-field>
      </div>

      <div class="d-flex flex-row">
        <mat-checkbox
          [checked]="uploadForm.controls.isContactNumberSelected.value"
          class="checkbox-style"
          (change)="requiredCheckOnContactPhone($event)"
        >
        </mat-checkbox>
        <el-multi-field
          class="col-11 pl-0"
          title="{{ 'identities.create-user.number-title' | translate }} "
          placeholder="{{
            'identities.create-user.number-placeholder' | translate
          }}"
          inputFieldId="create_identity_input_phone_number"
          btnId="create_identity_btn_set_phone"
          [required]="false"
          [isConstant]="false"
          [data]="{
            type: 'PHONE',
            value: uploadForm.controls.contactNumber.value,
            fieldConfig: null
          }"
          (onSetValue)="onValueChange($event)"
        ></el-multi-field>
      </div>
    </ng-container>
  </form>

  <mat-dialog-actions
    class="d-flex justify-content-end"
    style="margin-top: 20px"
  >
    <button mat-button (click)="onCancel()">
      {{ 'shared.remarks-popup.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="accent"
      (click)="onSave()"
      [disabled]="
        uploadForm.invalid ||
        (isContactDetailsRequired
          ? !uploadForm.controls.isContactNumberSelected.value &&
            !uploadForm.controls.isMailSelected.value
          : false) ||
        (isFileNeeded ? documentsDataList.length === 0 : false)
      "
    >
      {{ 'shared.remarks-popup.share' | translate }}
    </button>
  </mat-dialog-actions>
</div>
